import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getCustomFieldEmployeeById,
  modifyCustomFieldEmployee,
  getCustomFieldsEmployees,
  addCustomFieldEmployee,
  updateCustomFieldEmployee,
  addCustomField,
  removeCustomField,
} from '../actions';

import { getEditing } from '../selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { valueFromEvent, createRoute } from 'lib/util';

class EmployeesFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { eid } = this.props.match.params;
    this.props.reset();
    eid && this.props.getById(eid, this.props.company.id, this.props.subcompany.id);
    const filters = { fulltext: 'Drop Dawn', columnSearch: ['type'] }; // Filtros para traer solo los grupos de empleados
    this.props.getCustomFields(this.props.company.id, this.props.subcompany.id, filters);
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.employee.id
          ? this.props.update(
              this.props.employee.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.employee
            )
          : this.props.add(this.props.company.id, this.props.subcompany.id, this.props.employee);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(
                this.props.company.id,
                this.props.subcompany.id,
                'custom_fields_employees'
              )
            );
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  handleAddCustomField = () => this.props.addCustomField();

  handleRemoveCustomField = (index) => this.props.removeCustomField(index);

  handleValueChange = (e) => this.props.modify(valueFromEvent(e));

  handleDependentChange = (e) => {
    // const data = { [e.target.name]: { _id: e.target.value }, dependentId: e.target.value }
    const data = { [e.target.name]: { _id: e.target.value } };
    // console.log(e.target)
    this.props.modify(data);
  }; // Normal para input

  handleValidation = (isValid) => this.setState({ isValid });

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleDependentChange: this.handleDependentChange,
      handleAddCustomField: this.handleAddCustomField,
      handleRemoveCustomField: this.handleRemoveCustomField,
      handleValidation: this.handleValidation,
    });
}

const mapStateToProps = (state) => ({
  employee: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addCustomFieldEmployee,
  error: addGrowlError,
  getCustomFields: getCustomFieldsEmployees,
  getById: getCustomFieldEmployeeById,
  modify: modifyCustomFieldEmployee,
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateCustomFieldEmployee,
  addCustomField,
  removeCustomField,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmployeesFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/containers/EmployeeFormHandlers.js